<template>
  <div v-if="!loading">
    <Desktop v-if="!mobile" :menu="menu" />
    <Mobile v-else :menu="menu" />
  </div>
</template>

<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";
import { getMenu } from "../../../config";
import { formatToURL } from "../../../utils/formatToURL";

export default {
  data: () => ({
    loading: true,
    categories: [],
    occasions: [],
  }),
  created() {
    const categories = this.$rest("categories").get({
      save: (state, data) => (this.categories = data),
    });

    const occasions = this.$rest("categories").get({
      params: { fieldsId: 21, returnSubcategories: 0 },
      save: (state, data) =>
        (this.occasions = data.map(({ id, title }) => ({
          text: title,
          to: `/produtos?ocasiao=${formatToURL(title)}-${id}`,
        }))),
    });

    Promise.all([categories, occasions]).then(() => (this.loading = false));
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    baskets() {
      let category = this.categories.filter(
        ({ title }) => title.toLowerCase() === "cestas"
      );

      category = category[0];

      return category.subcategories.map(({ id, title }) => ({
        text: title,
        to: `/produtos?categoria=${formatToURL(category.title)}-${
          category.id
        }&subcategoria=${formatToURL(title)}-${id}`,
      }));
    },
    flowers() {
      let category = this.categories.filter(
        ({ title }) => title.toLowerCase() === "flores"
      );

      category = category[0];

      return category.subcategories.map(({ id, title }) => ({
        text: title,
        to: `/produtos?categoria=${formatToURL(category.title)}-${
          category.id
        }&subcategoria=${formatToURL(title)}-${id}`,
      }));
    },
    menu() {
      return this.getMenu(this);
    },
  },
  methods: {
    getMenu,
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>
